import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, alignItems } from '../../styles/helpers/flexbox';

export const Input = styled.input((props) => {
    const { typography } = ThemeHelper.getTheme(props);

    const borderStyle = props.isEditable ? 'grey' : 'transparent';
    const backgroundStyle = props.isEditable ? 'white' : 'rgba(0, 0, 0, 0)';
    return `
    width: 100%;
    background: ${backgroundStyle};
    border: 1px solid ${borderStyle};
    font-family: ${typography.family};
    outline: none;
    text-overflow: ellipsis;
    cursor: pointer;
    `;
});

export const InputToggleWrapper = styled.div`
    ${flexbox()}
    ${alignItems('end')}

    .icon {
        width: 20px;
        height: 21px;
        margin: 0 10px;
        float: right;
        cursor: pointer;
        outline: none;

        svg {
            path { fill: #8b8b8b !important; }
        }
    }
`;



// WEBPACK FOOTER //
// ./app/components/input-toggle/styled.js